import { getServiceRequestDrafts } from '@/sdk/clients/ServicesRequest'
import {
  getAllContracts,
  getAllServicesRequests,
} from '@/sdk/clients/MyCaregiversClient'
import logger from '@/sdk/logger'
import { RouteMeta } from '@/router'
import { RawLocation } from 'vue-router'
import store from '@/store'

export default async function getNextOrServiceRequestDraftPath<
  T extends RawLocation
>(
  meta: RouteMeta,
  route?: T,
): Promise<T | '/buchungsstatus/uebersicht' | '/anfrage'> {
  if (meta.appSection === 'customer-dashboard') {
    return route
  }

  try {
    const drafts = await getServiceRequestDrafts()

    if (!drafts?.length || drafts[0]?.payment) {
      return route
    }

    const [serviceRequests, contracts] = await Promise.all([
      getAllServicesRequests(),
      getAllContracts(),
    ])

    // If the user has an open SR draft but also has a SR or Contract
    // clear draft data from storage so the displayed navigation variation
    // is the for a logged in user and allow him to access the dashboard
    if (serviceRequests?.length || contracts?.length) {
      await store.dispatch('removeSRDraftDataFromLocalStorage')

      return route
    }

    return '/buchungsstatus/uebersicht'
  } catch (error) {
    logger.error('failed trying to redirect to dashboard or funnel', {
      error,
      tags: ['dashboard', 'routeGuard'],
    })

    return route
  }
}
